import { render, staticRenderFns } from "./SuccessfulApplicants.vue?vue&type=template&id=fcd2236c&scoped=true"
import script from "./SuccessfulApplicants.vue?vue&type=script&lang=js"
export * from "./SuccessfulApplicants.vue?vue&type=script&lang=js"
import style0 from "./SuccessfulApplicants.vue?vue&type=style&index=0&id=fcd2236c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd2236c",
  null
  
)

export default component.exports